import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { FaPlus } from 'react-icons/fa'
import { Button, useDisclosure } from "@heroui/react"

import { useRouter } from '@/hooks/use-router'
import { useContextSwitcher } from '@/hooks/use-context-switcher'

const ActivityEdit = dynamic(() => import('../activity-edit'), { ssr: false })
const ProgressGuage = dynamic(() => import('./guage'))
const ChallengeStatusDistance = dynamic(() => import('./distance'))
const ChallengeStatusElevation = dynamic(() => import('./elevation'))
const ChallengeStatusDuration = dynamic(() => import('./duration'))
const ChallengeStatusActivityGoal = dynamic(() => import('./activity-goal'))
const ChallengeStatusStreakGoal = dynamic(() => import('./streak-goal'))
const ChallengeStatusPoints = dynamic(() => import('./points'))

const ChallengeStatus = ({ challenge }) => {
  const [activityFormType, setActivityFormType] = useState('modal')
  const user = useContextSwitcher()
  const modal = useDisclosure()
  const router = useRouter()
  
  useEffect(() => {
    // Set different form types based on screen size
    const isMobileMedia = window.matchMedia('(max-width: 768px)').matches;
    const isMobileCheck = window.innerWidth <= 768 && 'ontouchstart' in window;
    setActivityFormType((isMobileMedia || isMobileCheck) ? 'panel' : 'modal')
  }, [])

  const type = challenge.isTeamChallenge ? 'teamResults' : 'userResults'
  let challengeJoined = false
  if (user && user.id && user.challengesJoined.find(c => { return c.id === challenge.id })) {
    challengeJoined = true
  }
  if (!challenge[type]) return <></> // if no type, that most likely means non-participant or public view 
  return <>
    {challenge.measure !== 'race' && 
      <div className='md:flex mb-12'>
        <div className='mb-8 md:mb-0 grow'>
          <div className='flex'>
            <div className='grow text-2xl font-normal leading-normal mt-0 mb-2 text-challengeHeaders '>{type === 'teamResults' ? 'Team' : 'Your'} Progress</div>
            <div className='flex-none'>
              {challengeJoined && challenge[type] && !challenge[type].completed && 
                <Button 
                  color='default'
                  size='sm'
                  className='bg-chTan-300'
                  onPress={() => {
                    if (user.ember) {
                      modal.onOpen()
                    } else {
                      router.push('/activity/new/edit') 
                    }
                  }}
                  startContent={<FaPlus className='text-primary' />}>
                    Log an Activity
                </Button>
              }
            </div>
          </div>
          {challenge[type] && <>
            {challenge.measure === 'distance' && <ChallengeStatusDistance type={type} summary={challenge} imperial={user.imperial} />}
            {challenge.measure === 'elevation' && <ChallengeStatusElevation type={type} summary={challenge} imperial={user.imperial} />}
            {challenge.measure === 'activityGoal' && <ChallengeStatusActivityGoal type={type} summary={challenge} imperial={user.imperial} />}
            {challenge.measure === 'durationGoal' && <ChallengeStatusDuration type={type} summary={challenge} imperial={user.imperial} />}
            {challenge.measure === 'streakGoal' && <ChallengeStatusStreakGoal type={type} summary={challenge} imperial={user.imperial} />}
            {challenge.measure === 'pointGoal' && <ChallengeStatusPoints type={type} summary={challenge} imperial={user.imperial} />}
          </>}
        </div>
        
        <div className='flex-none'>
          {(challenge && Boolean(Object.keys(challenge).length)) &&
            <ProgressGuage type={type} summary={challenge} />
          }
        </div>

      <ActivityEdit type={activityFormType} modal={modal} onSave={(newItem) => {
        modal.onClose()
        router.push(`/activity/${newItem.activity.id}`)
      }} />
      
      </div>
    }
    
    {challenge.measure === 'race' && <div>&nbsp;</div>}
  </>;
}

export default ChallengeStatus
